/*
Author: LiuBo
Date: 2018-09-05
Desc: 缓存对象，根据config.js 中的配置，在框架启动时请求接口并缓存。由main.js 引入，通过this.$cache 调用
*/
import conf from "@/config/index";
import util from "@/util";
import req from "@/assets/js/req";
import { httpClient } from "./http";
import store from "@/store";
import log from "@/assets/js/log";
import constant from "../../constant";
import commonApi from "@/api/common";
let cacheData = {
    _session: [],
    _headimage: sessionStorage.getItem("_headimage") || "",
    _userOtherInfo: JSON.parse(sessionStorage.getItem("_userOtherInfo")) || {},
    _dict: JSON.parse(sessionStorage.getItem("_dict")) || {},
    _params: JSON.parse(sessionStorage.getItem("_params")) || {},
    _user: JSON.parse(sessionStorage.getItem("_user")) || {},
    _userName: JSON.parse(sessionStorage.getItem("_userName")) || "",
    _notice: [],
    _advertise: [],
    _sysparam: [],
    _binded: JSON.parse(sessionStorage.getItem("binded")) || false,
    _validPwdTrdList: JSON.parse(sessionStorage.getItem("_validPwdTrdList")) || [],
    address: {
        citylists: JSON.parse(sessionStorage.getItem("citylists")) || {},
        countylists: JSON.parse(sessionStorage.getItem("countylists")) || {}
    },
    desensitization: JSON.parse(sessionStorage.getItem("desensitization")) || false,
    _moduleParam: JSON.parse(sessionStorage.getItem("_moduleParam")) || {}
};

/* 获取系统参数(UMP/JDAC 需要，其他产品不需要此方法)
  @inParam [String] pid 参数编号\
  return 参数值
  */
function getSysParam(pid) {
    if (pid === undefined) {
        return cacheData._params;
    } else {
        if (cacheData._params[pid]) {
            return cacheData._params[pid].paramvalue;
        }
    }
}
let cacheConf = {};
const _request = function (it, resolve, reject) {
    let item = it.next();
    if (!item.done) {
        cacheConf[item.value.code] = item.value;
    }
    if (!item.done && item.value.load) {
        log.trace("读取缓存配置: ", item.value);
        if (JSON.parse(sessionStorage.getItem(item.value.code)) && store.state.login.status) {
            log.trace("登录状态，不刷新缓存[" + item.value.code + "]");
            return _request(it, resolve, reject);
        }
        if (!cacheData._binded && item.value.code === "_user") {
            log.trace("未开户，不刷新缓存用户信息[" + item.value.code + "]");
            return _request(it, resolve, reject);
        }
        if (util.isV5Api(item.value.api)) {
            httpClient
                .request({
                    url: item.value.api,
                    method: item.value.method,
                    params: item.value.params || {},
                    data: item.value.params || {},
                    loader: false
                })
                .then((res) => {
                    if (item.value.code === "_dict") {
                        const _x = res.data;
                        const dict = {};
                        for (let item of _x) {
                            if (dict[item.dictitem]) {
                                dict[item.dictitem].push(item);
                            } else {
                                dict[item.dictitem] = [item];
                            }
                        }
                        cacheData[item.value.code] = dict;
                        sessionStorage.setItem("_dict", JSON.stringify(dict));
                    } else if (item.value.code === "_params") {
                        const _x = res.data;
                        const _param = {};
                        for (let item of _x) {
                            _param[item.paramname] = item;
                        }
                        cacheData[item.value.code] = _param;
                        sessionStorage.setItem("_params", JSON.stringify(_param));
                    } else if (item.value.code === "_moduleParam") {
                        const _x = res.data;
                        const _param = {};
                        for (let item of _x) {
                            _param[item.paramname] = item;
                        }
                        cacheData[item.value.code] = _param;
                        sessionStorage.setItem("_moduleParam", JSON.stringify(_param));
                    } else {
                        cacheData[item.value.code] = res.data;
                    }
                    if (item.value.code === "_session") {
                        sessionStorage.setItem("_a", JSON.stringify(res.data[0][0]));
                    }
                    log.trace("缓存[" + item.value.code + "] 加载完成");
                    _request(it, resolve, reject);
                })
                .catch((err) => {
                    if (err.code === "9999999" && item.value.code === "_session") {
                        cacheData[item.value.code] = err.data;
                        log.trace("缓存[" + item.value.code + "] 加载完成");
                        _request(it, resolve, reject);
                    } else {
                        log.trace("缓存加载失败", err);
                        resolve();
                    }
                });
        } else {
            req({
                url: item.value.api,
                method: item.value.method,
                params: item.value.params || {},
                loader: false
            })
                .then((res) => {
                    if (item.value.code === "_dict") {
                        const _x = res.record[0];
                        const dict = {};
                        for (let item of _x) {
                            if (dict[item.dictitem]) {
                                dict[item.dictitem].push(item);
                            } else {
                                dict[item.dictitem] = [item];
                            }
                        }
                        cacheData[item.value.code] = dict;
                    } else if (item.value.code === "_params") {
                        const _x = res.record[0];
                        const _param = {};
                        for (let item of _x) {
                            _param[item.paramname] = item.paramvalue;
                        }
                        cacheData[item.value.code] = _param;
                    } else {
                        cacheData[item.value.code] = res.record[0];
                    }
                    if (item.value.code === "_session") {
                        sessionStorage.setItem("_a", JSON.stringify(res.record[0][0]));
                    }
                    log.trace("缓存[" + item.value.code + "] 加载完成");
                    _request(it, resolve, reject);
                })
                .catch((err) => {
                    if (err.code === "9999999" && item.value.code === "_session") {
                        cacheData[item.value.code] = err.record[0];
                        log.trace("缓存[" + item.value.code + "] 加载完成");
                        _request(it, resolve, reject);
                    } else {
                        log.trace("缓存加载失败", err);
                        resolve();
                    }
                });
        }
    } else {
        log.info("全部缓存处理完毕");
        resolve();
    }
};
export default {
    /* 初始化缓存对象（开始进行缓存）。本方法由main.js 调用，缓存全部处理完毕后才绘制入口页面
  @inParam 无
  @return [Object] Promise
  @promise-then 无参数，在缓存全部处理完毕后触发
  */
    init() {
        return new Promise((resolve, reject) => {
            let iterator = util.iterator(conf.cache);
            _request(iterator, resolve, reject);
        });
    },
    /* 刷新缓存
  @inParam [String] 缓存代码
  @return [Object] Promise
  @Promise-then [Array] 刷新后的缓存数据结果集
  */
    refresh(code) {
        let that = this;
        const _x = conf.cache.find((item) => {
            return item.code === code;
        });
        if (_x) {
            return new Promise((resolve, reject) => {
                if (util.isV5Api(_x.api)) {
                    if (code === "_user" && !cacheData._binded) return;
                    httpClient
                        .request({
                            url: _x.api,
                            method: _x.method
                            // loader: false //默认添加loader
                        })
                        .then((res) => {
                            // TODO: 根据5.0接口返回的数据做处理
                            if (code === "_dict") {
                                const _x = res.data;
                                const dict = {};
                                for (let item of _x) {
                                    if (dict[item.dictitem]) {
                                        dict[item.dictitem].push(item);
                                    } else {
                                        dict[item.dictitem] = [item];
                                    }
                                }
                                cacheData[code] = dict;
                            } else if (code === "_params") {
                                const _x = res.data;
                                const _param = {};
                                for (let item of _x) {
                                    _param[item.name] = item.value;
                                }
                                cacheData[code] = _param;
                            } else {
                                cacheData[code] = res.data;
                            }
                            let returnData = res.data;
                            // for (let item of res.data) {
                            //     returnData[returnData.length] = Object.assign(
                            //         {},
                            //         item
                            //     );
                            // }
                            switch (code) {
                                case "_session":
                                    that.setSession(cacheData[code]);
                                    break;
                                case "_user":
                                    cacheData[code].ismatch = cacheData[code].qryallfund
                                        ? cacheData[code].qryallfund === "0"
                                            ? "1"
                                            : "0"
                                        : "1";
                                    that.setUser(cacheData[code]);
                                    break;
                            }
                            resolve(returnData);
                        })
                        .catch((err) => reject(err));
                } else {
                    req({
                        url: _x.api,
                        method: _x.method
                        // loader: false //默认添加loader
                    })
                        .then((res) => {
                            if (code === "_dict") {
                                const _x = res.record[0];
                                const dict = {};
                                for (let item of _x) {
                                    if (dict[item.dictitem]) {
                                        dict[item.dictitem].push(item);
                                    } else {
                                        dict[item.dictitem] = [item];
                                    }
                                }
                                cacheData[code] = dict;
                            } else if (code === "_params") {
                                const _x = res.record[0];
                                const _param = {};
                                for (let item of _x) {
                                    _param[item.name] = item.value;
                                }
                                cacheData[code] = _param;
                            } else {
                                cacheData[code] = res.record[0];
                            }
                            let returnData = [];
                            for (let item of res.record[0]) {
                                returnData[returnData.length] = Object.assign({}, item);
                            }

                            switch (code) {
                                case "_session":
                                    that.setSession(cacheData[code][0]);
                                    break;
                                case "_user":
                                    cacheData[code].ismatch = cacheData[code].qryallfund
                                        ? cacheData[code].qryallfund === "0"
                                            ? "1"
                                            : "0"
                                        : "1";
                                    that.setUser(cacheData[code][0]);
                                    break;
                            }
                            resolve(returnData);
                        })
                        .catch((err) => reject(err));
                }
            });
        }
    },
    /* 获取缓存数据
  @inParam [String] 缓存代码
  @return [Array] 缓存数据结果集
  */
    get(code) {
        if (code === undefined) {
            return cacheData;
        } else if (code.indexOf(0) === "_") {
            let returnData = [];
            for (let item of cacheData[code]) {
                returnData[returnData.length] = Object.assign({}, item);
            }
            return returnData;
        } else {
            return cacheData[code];
        }
    },
    /* 设置自定义缓存数据
  @inParam [String] 缓存代码, 不允许以下划线_开头（框架内部缓存数据以下划线开头）
  @inParam [Any] 要缓存的数据
  @return 无
  */
    set(code, val) {
        if (code.indexOf(0) === "_") {
            return false;
        } else {
            cacheData[code] = val;
        }
    },
    /* 针对内部缓存数据提供的方法 : 获取会话token
  @inParam 无
  @return [String] 会话token
  */
    getSessionToken() {
        let storedSession = sessionStorage.getItem("_a");
        let storedToken = "";
        if (storedSession) {
            storedToken = JSON.parse(storedSession).token;
        }
        return cacheData._session.length === 0 ? storedToken : cacheData._session[0].token;
    },
    /* 针对内部缓存数据提供的方法 : 获取本次会话的有效加密因子
  @inParam 无
  @return [String] 本次会话有效的加密因子
  */
    getSessionKey() {
        let storedSession = sessionStorage.getItem("_a");
        let storedKey = "";
        if (storedSession) {
            storedKey = JSON.parse(storedSession).key;
        }
        return cacheData._session.length === 0 ? storedKey : cacheData._session[0].key;
    },
    /* 针对内部缓存数据提供的方法 : 设置会话信息
  @inParam [Object] 可选，会话信息对象. 包含token 和key 属性。如不提供则清空会话信息。
  本方法一般由store.dispatch('login') 和store.dispatch('logout') 内部调用。
  store.dispatch('login') 登录后立即调用，登录接口会返回key和token，需要将这些数据存入缓存便于框架后续使用
  store.dispatch('logout') 注销、刷新、超时后调用，将在清空会话信息后再次刷新会话
  @return 无
  */
    setSession(d) {
        if (d) {
            cacheData._session = [
                {
                    token: d.token,
                    key: d.key
                }
            ];
            sessionStorage.setItem("_a", '{"token":"' + d.token + '","key":"' + d.key + '"}');
            localStorage.setItem("_a", d.token);
        } else {
            cacheData._session = [];
            sessionStorage.removeItem("_a");
            localStorage.removeItem("_a");
        }
    },
    /* 针对内部缓存数据提供的方法 : 获取数据字典
  @inParam [String] 字典编号
  @inParam [String] 可选，字典项取值
  @return [Array] 如果未提供字典项取值，则返回该字典编号下的所有字典项结果集
  @return [String] 如果同时提供了字典编号和字典取值，则返回该字典编号下，取值为subItem 的字典项的subitemname
  */
    getDict(dictItem, subItem, riskSpecial = true) {
        if (dictItem === undefined) {
            return cacheData._dict;
        }
        /* if (dictItem === "100017") {
            cacheData._dict[dictItem] = [
                {sysid: "4", dictitem: "100017", subitem: "04", subitemname: "C4-积极型", remark: "风险承受能力"},
                {sysid: "4", dictitem: "100017", subitem: "05", subitemname: "C5-激进型"},
                {sysid: "4", dictitem: "100017", subitem: "01", subitemname: "C1-安逸型"},
                {sysid: "4", dictitem: "100017", subitem: "02", subitemname: "C2-保守型"},
                {sysid: "4", dictitem: "100017", subitem: "03", subitemname: "C3-稳健型"}
            ];
        } */
        /* if (dictItem === "110143") {
            cacheData._dict[dictItem] = [
                {sysid: "4", dictitem: "110143", subitem: "01", subitemname: "R1-低", remark: "产品风险等级"},
                {sysid: "4", dictitem: "110143", subitem: "02", subitemname: "R2-中低"},
                {sysid: "4", dictitem: "110143", subitem: "03", subitemname: "R3-中"},
                {sysid: "4", dictitem: "110143", subitem: "04", subitemname: "R4-中高"},
                {sysid: "4", dictitem: "110143", subitem: "05", subitemname: "R5-高"}
            ];
        } */
        if (subItem === undefined) {
            return cacheData._dict[dictItem];
        } else {
            if (String(subItem).indexOf(",") > -1) {
                let _x = "";
                const _itemArr = String(subItem).split(",");
                for (let i of _itemArr) {
                    for (let item of cacheData._dict[dictItem]) {
                        if (item.subitem.trim() === String(i)) {
                            let name = Object.assign({}, item).subitemname;
                            if (riskSpecial) {
                                if (dictItem === "110143") {
                                    const level = parseInt(item.subitem);
                                    const cleanName = name
                                        .replace(/R\d+[-]?/, "")
                                        .replace("风险", "");
                                    name = `${cleanName}风险(R${level})`;
                                } else if (dictItem === "100017") {
                                    const level = parseInt(item.subitem);
                                    const lowriskflag = this.getUser().lowriskflag;
                                    if (lowriskflag === "1") {
                                        name = `最低风险等级(C${level})`;
                                    } else {
                                        const cleanName = name
                                            .replace(/C\d+[-]?/, "")
                                            .replace("承受能力", "");
                                        name = `${cleanName}(C${level})`;
                                    }
                                }
                            }
                            _x += name + ",";
                            break;
                        }
                    }
                }
                return _x.substr(0, _x.length - 1);
            }
            if (!cacheData._dict[dictItem]) {
                return "";
            }

            for (let item of cacheData._dict[dictItem]) {
                if (item.subitem.trim() === String(subItem)) {
                    let name = Object.assign({}, item).subitemname;
                    if (riskSpecial) {
                        if (dictItem === "110143") {
                            const level = parseInt(item.subitem);
                            const cleanName = name.replace(/R\d+[-]?/, "").replace("风险", "");
                            name = `${cleanName}风险(R${level})`;
                        } else if (dictItem === "100017") {
                            const level = parseInt(item.subitem);
                            const lowriskflag = this.getUser().lowriskflag;
                            if (lowriskflag === "1") {
                                name = `最低风险等级(C${level})`;
                            } else {
                                const cleanName = name
                                    .replace(/C\d+[-]?/, "")
                                    .replace("承受能力", "");
                                name = `${cleanName}(C${level})`;
                            }
                        }
                    }
                    return name;
                }
            }
            return "";
        }
    },
    /* 针对内部缓存数据提供的方法 : 获取公司信息
  @inParam [String] 可选，指定要获取的公司信息参数名
  @return [Object] 如未提供参数名，则返回内含所有公司信息的Object, key为参数名，value 为参数值
  @return [String] 如提供了参数名，则返回指定参数名的参数值
  */
    getCompanyInfo(key) {
        let info = cacheData._params;
        // return key === undefined ? info : info[key];
        return key === undefined ? info : info[key] ? info[key].paramvalue : "";
    },
    /* 针对内部缓存数据提供的方法 : 获取5.0杂参
    @inParam [String] 可选指定杂参
    @return [String] 如提供了参数名，则返回指定参数名的参数值
    */
    getCompanyInfoParam(key) {
        let info = cacheData._params;
        return key === undefined ? info : info[key] ? info[key].paramvalue || "" : "";
    },
    /* 针对内部缓存数据提供的方法 : 获取公司信息
 @inParam [String] 可选，指定要获取的公司信息参数名
 @return [String] 如提供了参数名，则返回指定参数名的参数值
 */
    getAdvertiseInfo(key) {
        let info = cacheData._advertise || [];
        const _x = info.filter((item) => {
            return item.bannertype === String(key);
        });
        return _x || [];
    },
    /* 针对内部缓存数据提供的方法 : 设置用户信息
  @inParam [Object] 用户信息键值对。本方法一般应在登录后获取到用户信息、或用户信息发生改变后立即调用。
  @return 无
  */
    setUser(d) {
        // d.mobileno = ""; // 临时代码
        // d.en_mobileno = ""; // 临时代码
        cacheData._user = Object.assign({}, d);
        sessionStorage.setItem("_user", JSON.stringify(d));
    },
    setUserName(d) {
        cacheData._userName = d;
        sessionStorage.setItem("_userName", JSON.stringify(d));
    },
    setHeadImage(d) {
        cacheData._headimage = d;
        sessionStorage.setItem("_headimage", d);
    },
    setUserOtherInfo(d) {
        // 前端登录塞入的值
        if (cacheData._userOtherInfo.accttype) d.accttype = cacheData._userOtherInfo.accttype;

        cacheData._userOtherInfo = d;
        sessionStorage.setItem("_userOtherInfo", JSON.stringify(d));
    },
    /* 针对内部用户信息缓存数据更新提供的方法 : 更新用户信息(网上交易/APP/微信/网站需要此方法更新用户信息, UMP不需要)
  @return 无
  */
    refreshUser(cb) {
        const _this = this;
        this.refresh("_user").then((res) => {
            _this.setUser(res);
            if (cb) {
                cb.call(this);
            }
        });
    },
    /* 针对内部缓存数据提供的方法 : 获取用户信息
  @inParam 无
  @return [Object] 用户信息键值对
  */
    getUser() {
        return cacheData._user;
    },
    /* 针对内部缓存数据提供的方法 : 获取用cms 用户id
    @inParam 无
    */
    getUserName() {
        return cacheData._userName;
    },
    /* 针对内部缓存数据提供的方法 : 清空用户信息
  @inParam 无
  @return 无
  */
    clearUser() {
        cacheData._user = {};
        cacheData._binded = false;
        cacheData._userOtherInfo = {};
        cacheData._userName = "";
        cacheData._session = [];
        sessionStorage.removeItem("_user");
        sessionStorage.removeItem("binded");
        sessionStorage.removeItem("_userOtherInfo");
        sessionStorage.removeItem("desensitization");
    },
    /* 针对内部缓存数据提供的方法 : 设置是否开户 状态
    @inParam [Boolean]
    @return 无
    */
    setBinded(flag) {
        cacheData._binded = flag;
        sessionStorage.setItem("binded", JSON.stringify(flag));
    },
    /* 针对内部缓存数据提供的方法 : 用户是否开户
     @inParam 无
     @return [Boolean]
    */
    getBinded() {
        // 兼容纯代销客户
        let isCustnoCrm =
            cacheData._userOtherInfo && // 确保对象存在
            cacheData._userOtherInfo.custnoCrm !== undefined && // 检查字段存在
            cacheData._userOtherInfo.custnoCrm !== null && // 排除 null
            cacheData._userOtherInfo.custnoCrm !== ""; // 排除空字符串
        return cacheData._binded || JSON.parse(sessionStorage.getItem("binded"));
        // return cacheData._binded || JSON.parse(sessionStorage.getItem("binded")) || isCustnoCrm;
    },
    /* 针对是否是纯代销客户
     @inParam 无
     @return [Boolean]
    */
    getCustnoCrm() {
        let obj = cacheData._user || JSON.parse(sessionStorage.getItem("_user"));
        if ("custnoCrm" in obj) {
            return true;
        } else {
            return false;
        }
    },
    /* 获取系统参数(UMP/JDAC 需要，其他产品不需要此方法)
  @inParam [String] pid 参数编号\
  return 参数值
  */
    getSysParam,
    /**
     * 查询业务是否需要验证交易密码
     * description: 查询业务是否需要验证交易密码
     * @param businesscode: 业务码
     * @param invtp: 客户类型 默认个人
     * @return
     */
    async queryValidPwdTrdMethod() {
        const res = await commonApi.queryValidPwdTrdMethod({
            acceptmethodstr: util.getConfig().systemtype,
            invtp: "1"
        });
        const list = res.data || [];
        this.setValidPwdTrdList(list);
    },
    /* 获取业务是否需要校验密码参数(网上交易需要，其他产品不需要此方法)
  @inParam [String] pid 业务类型参数编号
  return 参数值
  */
    getPwdCheck(pid) {
        if (!pid || pid === "") return false;
        let arr = pid.split(",");
        let ret = arr.map((item) => (item.startsWith("0") ? item : "0" + item));
        let flag = false;
        ret.forEach((ppid) => {
            const method = cacheData._validPwdTrdList.find((item) => {
                return item.businesscode == ppid && item.invtp && item.invtp.includes("1");
            });
            if (method) {
                flag = true;
            }
        });
        return flag;
    },
    /* 获取对应路由是否存在温馨提示
  @inParam [String] pid 业务类型参数编号
  return 参数值
  */
    getNotice(pid) {
        if (!pid || pid === "") return false;
        const _check = cacheData._notice || [];
        const _x = _check.find((item) => {
            return item.route === pid;
        });
        return _x || "";
    },
    /* 获取现金宝基金代码(网上交易需要，其他产品不需要此方法)
  @inParam [String] pid 业务类型参数编号
  return 参数值
  */
    getXjbCode() {
        return cacheData._params.xjbfundcode ? cacheData._params.xjbfundcode.replace(",", "") : "";
    },
    /* 针对内部缓存数据提供的方法 : 获取增值模块状态
  @inParam [String] 模块编号
  @return [Object] 模块编号状态
  */
    getStatus(code) {
        for (let list of cacheData._modulestatus) {
            if (list.modulecode == conf.modulecode[code]) {
                return list.status;
            }
        }
    },
    /* 获取常用邮箱配置间 */
    getEmailSuffix() {
        return cacheData._params.email_suffix;
    },
    /* 获取交易页面信批文件强制阅读的配置时间 */
    getReadTime() {
        return cacheData._params.readfile_time;
    },
    getOcrFileSize() {
        const upFileSize = getSysParam("10110004");
        return upFileSize;
    },
    getChannelLimit(channel, key) {
        const limit = cacheData._params[channel + "_limit_" + key];
        return limit && limit.trim();
    },
    // 获取_params数据
    getParams(key) {
        let info = cacheData._params;
        return key === undefined ? info : info[key];
    },
    // 需要校验交易密码的业务载入缓存
    setValidPwdTrdList(list) {
        cacheData._validPwdTrdList = Object.assign([], list);
        sessionStorage.setItem("_validPwdTrdList", JSON.stringify(list));
    },
    // 获取头像数据
    getHeadImage() {
        return cacheData._headimage;
    },
    // 获取其它用户信息
    getUserOtherInfo() {
        return cacheData._userOtherInfo;
    },
    // 城市信息载入缓存
    initCityCountyList() {
        let address = this.get("address");
        let citylists = cacheData["address"]["citylists"];
        let countylists = cacheData["address"]["countylists"];
        if (Object.keys(citylists).length === 0 || !citylists) {
            citylists = this.getDict(constant.DICT.CITY) || [];

            // 创建一个空对象作为结果存放容器
            const citylistobj = {};
            // 遍历原始数组
            citylists.forEach(function (item) {
                let key = item.subitem.slice(0, 2) + "0000";
                if (!citylistobj[key]) {
                    // 如果该key不存在于结果对象中，则初始化一个新的数组
                    citylistobj[key] = [];
                    // 将当前项添加到对应交易账号的数组中
                    citylistobj[key].push({
                        cityid: item.subitem,
                        cityname: item.subitemname
                    });
                } else {
                    citylistobj[key].push({
                        cityid: item.subitem,
                        cityname: item.subitemname
                    });
                }
            });
            address["citylists"] = citylistobj;
            sessionStorage.setItem("citylists", JSON.stringify(address["citylists"]));
        }
        if (Object.keys(countylists).length === 0 || !citylists) {
            countylists = this.getDict(constant.DICT.COUNTY) || [];

            // 创建一个空对象作为结果存放容器
            const countylistobj = {};
            // 遍历原始数组
            countylists.forEach(function (item) {
                let key = item.subitem.slice(0, 4) + "00";
                if (!countylistobj[key]) {
                    // 如果该key不存在于结果对象中，则初始化一个新的数组
                    countylistobj[key] = [];
                    // 将当前项添加到对应交易账号的数组中
                    countylistobj[key].push({
                        countyid: item.subitem,
                        countyname: item.subitemname
                    });
                } else {
                    countylistobj[key].push({
                        countyid: item.subitem,
                        countyname: item.subitemname
                    });
                }
            });
            address["countylists"] = countylistobj;
            sessionStorage.setItem("countylists", JSON.stringify(address["countylists"]));
        }
    },
    // 设置是否脱敏
    async setDesensitization() {
        // 通过接口判断是否需要脱敏
        const { data } = await commonApi.queryDesensitization({});
        sessionStorage.setItem(
            "desensitization",
            JSON.stringify((data && data.desensitization) || false)
        );
        cacheData.desensitization = (data && data.desensitization) || false;
        util.getConfig().isKen = Boolean((data && data.desensitization) || false);
    },
    // 获取是否脱敏
    getIsEncrypted() {
        return cacheData.desensitization;
    },
    /**
     * 从配置数据中提取并解析指定paramname的paramvalue
     * @param {String} paramName - 目标paramname名称（如'fund_market'）
     * @returns {Object|null} 解析后的JSON对象，未找到返回null
     */
    getParamValue(paramName) {
        // 1. 查找目标配置项
        const targetConfig = Object.values(cacheData._moduleParam).find(
            (item) => item.paramname === paramName
        );
        // 2. 安全校验与解析
        if (targetConfig && targetConfig.paramvalue) {
            try {
                return JSON.parse(targetConfig.paramvalue);
            } catch (error) {
                console.error(`JSON解析失败 (${paramName}):`, error);
                return null;
            }
        }
        return null;
    }
};
